import type { ICustomerQuery } from "@repo/shopify/src/queries/customer-gql";
import React from "react";
import { useTranslation } from "react-i18next";

import Button from "@components/atoms/Button";
import Icon from "@components/atoms/Icon";
import LoadingIcon from "@components/atoms/LoadingIcon";

import useSocialLogin from "@hooks/useSocialLogin";

import { IconName } from "@const/enum";

interface IProps {
  onComplete: (accessToken?: string, customer?: ICustomerQuery["customer"]) => void;
}

function KakaoLogin({ onComplete }: IProps) {
  const { t } = useTranslation();
  const { isProgressing, isLoading, kakaoLogin } = useSocialLogin({ onComplete });

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <Button isLoading={isProgressing || isLoading} onClick={kakaoLogin} styleType="primary" variant="social">
      <span className="flex w-full items-center justify-center gap-[8px]">
        <Icon alt={t("login.kakao_login")} className="size-[14px]" name={IconName.Kakao} />
        <span>{t("login.kakao_continue")}</span>
      </span>
    </Button>
  );
}

export default KakaoLogin;
